export const getHighestProbableActionTypeId = actionTypeIdProbabilityMap => {
  let highestProbableActionTypeId = '';
  let highestProbability = -1;
  Object.entries(actionTypeIdProbabilityMap).forEach(([actionTypeId, probability]) => {
    if (probability > highestProbability) {
      highestProbability = probability;
      highestProbableActionTypeId = actionTypeId;
    }
  });
  return {
    actionTypeId: highestProbableActionTypeId,
    probability: highestProbability
  };
};